module.exports = __webpack_public_path__ + "media/images/lb/316-4f4e44b7c9f5b321e23511a403b8878f.svg";